import { InjectionToken } from '@angular/core';
import { DigitalDataService } from 'ib-web-commons/app/core/ib-datalayer/services/ib-digital-data-service';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsDigitalDataService = new InjectionToken('DigitalDataService');
export const AJSGiftCardsDigitalDataServiceProvider = upgradeAJSServiceProvider('DigitalDataService', AJSGiftCardsDigitalDataService);
export interface GiftCardsDigitalDataServiceType extends DigitalDataService {
    initKeepAlive()
}
